import React, {Component, Fragment} from 'react';
import {connect} from "react-redux";
import {getBillingDetails} from "../../actionCreators";

class BillingDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSubmittedForm: false,
      billing_match_customer: false,
      name: null,
      surname: null,
      phone: null,
      email: null,
      billing_name: null,
      billing_surname: null,
      order_number: null,
      billing_address: {
        country: null,
        city: null,
        zip: null,
        street: null,
        house: null
      }
    }
  }

  handleInputChange = (event) => {
    const {billingDetails} = this.props;
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    if(!value && billingDetails) {
      billingDetails[name] = ""
    }
    this.setState({
      [name]: value
    });
  };

  handleDeepInputChange = (event) => {
    const {billingDetails} = this.props;
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({
      billing_address: {
        ...this.state.billing_address,
        [name]: value
      }
    });
    if(!value && billingDetails) {
      billingDetails[name] = ""
    }
  };

  handleNextStepBtn = () => {
    const {handleNextStep, getBillingDetails, deliveryAddress, billingDetails} = this.props;
    const {name, surname, phone, email, order_number, billing_address, billing_match_customer, billing_name, billing_surname} = this.state;
    const {validateEmail} = this;

    this.setState({
      isSubmittedForm: true
    });

    const billingMatchCustomer = (billing_match_customer || (billingDetails && billingDetails.billing_match_customer)) === null ? false : (billing_match_customer || (billingDetails && billingDetails.billing_match_customer));

    this.setState({
      name: (name || (billingDetails && billingDetails.name)),
      surname: (surname || (billingDetails && billingDetails.surname)),
      phone: (phone || (billingDetails && billingDetails.phone)),
      email: (email || (billingDetails && billingDetails.email)),
      order_number: (order_number || (billingDetails && billingDetails.order_number)),
      billing_name: billingMatchCustomer ? billing_name || (billingDetails && billingDetails.billing_name) : (billingDetails && billingDetails.name),
      billing_surname: billingMatchCustomer ? billing_surname || (billingDetails && billingDetails.billing_surname) : (billingDetails && billingDetails.surname),
      billing_match_customer: billingMatchCustomer,
      billing_address: {
        ...this.state.billing_address,
        country: billing_address.country || (billingDetails && billingDetails.billing_address.country),
        city: billing_address.city || (billingDetails && billingDetails.billing_address.city),
        zip: billing_address.zip || (billingDetails && billingDetails.billing_address.zip),
        street: billing_address.street || (billingDetails && billingDetails.billing_address.street),
        house: billing_address.house || (billingDetails && billingDetails.billing_address.house)
      }
    });

    const fetchData = {};
    const fetchDataAddress = {};
    fetchData.name = name || (billingDetails && billingDetails.name);
    fetchData.surname = surname || (billingDetails && billingDetails.surname);
    fetchData.phone = phone || (billingDetails && billingDetails.phone);
    fetchData.email = email || (billingDetails && billingDetails.email);
    fetchData.order_number = order_number || (billingDetails && billingDetails.order_number);
    fetchData.billing_match_customer = billingMatchCustomer;
    fetchData.billing_address = fetchDataAddress;
    fetchData.billing_name = billingMatchCustomer ? billing_name || (billingDetails && billingDetails.billing_name) : name || (billingDetails && billingDetails.name);
    fetchData.billing_surname = billingMatchCustomer ? billing_surname || (billingDetails && billingDetails.billing_surname) : surname || (billingDetails && billingDetails.surname);
    fetchDataAddress.country = billingMatchCustomer ? billing_address.country || (billingDetails && billingDetails.billing_address.country) : deliveryAddress.delivery_address.country;
    fetchDataAddress.city = billingMatchCustomer ? billing_address.city || (billingDetails && billingDetails.billing_address.city) : deliveryAddress.delivery_address.city;
    const zip = billingMatchCustomer ? billing_address.zip || (billingDetails && billingDetails.billing_address.zip) : deliveryAddress.delivery_address.zip;
    fetchDataAddress.zip = zip + '';
    fetchDataAddress.street = billingMatchCustomer ? billing_address.street || (billingDetails && billingDetails.billing_address.street) : deliveryAddress.delivery_address.street;
    fetchDataAddress.elevator_available = billingMatchCustomer ? false : deliveryAddress.delivery_address.elevator_available;
    const house = billingMatchCustomer ? billing_address.house || (billingDetails && billingDetails.billing_address.house) : deliveryAddress.delivery_address.house;
    fetchDataAddress.house = house + '';

    if(
      (name || (billingDetails && billingDetails.name)) &&
      (surname || (billingDetails && billingDetails.surname)) &&
      (validateEmail(email) || validateEmail((billingDetails && billingDetails.email))) &&
      (phone || (billingDetails && billingDetails.phone)) &&
      (order_number || (billingDetails && billingDetails.order_number)) &&
      (!billingMatchCustomer || (billing_address.country || (billingDetails && billingDetails.billing_address.country))) &&
      (!billingMatchCustomer || (billing_address.city || (billingDetails && billingDetails.billing_address.city))) &&
      (!billingMatchCustomer || (billing_address.zip || (billingDetails && billingDetails.billing_address.zip))) &&
      (!billingMatchCustomer || (billing_address.street || (billingDetails && billingDetails.billing_address.street))) &&
      (!billingMatchCustomer || (billing_address.house || (billingDetails && billingDetails.billing_address.house)))
    ) {
      // console.log('S1 send ajax')
      // console.log(fetchData)
      getBillingDetails(fetchData);
      handleNextStep();
    } else {
      console.log('S2 not send ajax')
    }
  };

  handleSubmit = (e) => {
    e.preventDefault();
  };

  matchCustomerData = (e) => {
    const {billingDetails} = this.props;
    const value = e.target.value;
    this.setState({
      billing_match_customer: !JSON.parse(value)
    });
    if(billingDetails) {
      billingDetails.billing_match_customer = !JSON.parse(value);
    }

    if(!JSON.parse(value)) {
      billingDetails.billing_name = null;
      billingDetails.billing_surname = null;
      billingDetails.billing_address.country = null;
      billingDetails.billing_address.city = null;
      billingDetails.billing_address.zip = null;
      billingDetails.billing_address.street = null;
      billingDetails.billing_address.house = null;
      this.setState({
        billing_name: null,
        billing_surname: null,
        billing_address: {
          ...this.state.billing_address,
          country: null,
          city: null,
          zip: null,
          street: null,
          house: null
        }
      });
    }
  };

  validateEmail = (email) => {
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  };

  render() {
    const {handleNextStepBtn, handleSubmit, matchCustomerData, handleDeepInputChange, handleInputChange, validateEmail} = this;
    const {isSubmittedForm} = this.state;
    const {billingDetails} = this.props;
    const {name, surname, order_number, billing_address, billing_match_customer, email, phone, billing_name, billing_surname} = this.state;

    return (
      <Fragment>
        <section className="billing-details">
          <h1>verbindlich bestellen</h1>
          <div className="billing-details__wrap">
            <h2>Persönliche Daten</h2>
            <form onSubmit={handleSubmit} method="POST" action="true">
              <div className="billing-details__row billing-details__row--two">
                <div className={"input-wrap input-wrap--common " + (!name && isSubmittedForm ? 'form__error' : '')}>
                  <label>Vorname</label>
                  <input name="name" onChange={handleInputChange} defaultValue={name || (billingDetails && billingDetails.name)} type="text" required />
                </div>
                <div className={"input-wrap input-wrap--common " + (!surname && isSubmittedForm ? 'form__error' : '')}>
                  <label>Nachname</label>
                  <input name="surname" onChange={handleInputChange} defaultValue={surname || (billingDetails && billingDetails.surname)} type="text" required />
                </div>
              </div>
              <div className="billing-details__row billing-details__row--two">
                <div className={"input-wrap input-wrap--common " + (!validateEmail(email) && isSubmittedForm ? 'form__error' : '')}>
                  <label>Email</label>
                  <input name="email" onChange={handleInputChange} defaultValue={email || (billingDetails && billingDetails.email)} type="text" required />
                </div>
                <div className={"input-wrap input-wrap--common " + (!phone && isSubmittedForm ? 'form__error' : '')}>
                  <label>Telefon</label>
                  <input name="phone" onChange={handleInputChange} defaultValue={phone || (billingDetails && billingDetails.phone)} type="text" required />
                </div>
              </div>
              <div className="billing-details__row">
                <div className={"input-wrap input-wrap--common " + (!order_number && isSubmittedForm ? 'form__error' : '')}>
                  <label>Belegnummer</label>
                  <input name="order_number" onChange={handleInputChange} defaultValue={order_number || (billingDetails && billingDetails.order_number)} type="text" required />
                </div>
                {!order_number && isSubmittedForm ? <div className="form__error form__error--text">Bitte tragen Sie Ihre Rechnungs- oder Quittungsnummer ein</div> : ''}
              </div>
              <div className="billing-details__row">
                <div className="check-wrap check-wrap--common">
                  <input type="checkbox" name="billing_match_customer" id="shipping-address" checked={!(billingDetails && billingDetails.billing_match_customer || billing_match_customer)} defaultValue={(billingDetails && billingDetails.billing_match_customer || billing_match_customer)} onChange={matchCustomerData} required />
                  <label htmlFor="shipping-address">Rechnungsadresse wie Lieferadresse</label>
                </div>
              </div>
              { (billingDetails && billingDetails.billing_match_customer || billing_match_customer) ? (
                <Fragment>
                  <div className="billing-details__row billing-details__row--two">
                    <div className={"input-wrap input-wrap--common " + (!billing_name && isSubmittedForm ? 'form__error' : '')}>
                      <label>Vorname</label>
                      <input name="billing_name" onChange={handleInputChange} value={billing_name || (billingDetails && billingDetails.billing_name)} type="text" required />
                    </div>
                    <div className={"input-wrap input-wrap--common " + (!billing_surname && isSubmittedForm ? 'form__error' : '')}>
                      <label>Nachname</label>
                      <input name="billing_surname" onChange={handleInputChange} value={billing_surname || (billingDetails && billingDetails.billing_surname)} type="text" required />
                    </div>
                  </div>
                  <div className="billing-details__row billing-details__row--three">
                    <div className={"input-wrap input-wrap--common " + (!billing_address.country && isSubmittedForm ? 'form__error' : '')}>
                      <label>Land</label>
                      <input name="country" onChange={handleDeepInputChange} value={billing_address.country || (billingDetails && billingDetails.billing_address.country)} type="text" required />
                    </div>
                    <div className={"input-wrap input-wrap--common " + (!billing_address.city && isSubmittedForm ? 'form__error' : '')}>
                      <label>Stadt</label>
                      <input name="city" onChange={handleDeepInputChange} value={billing_address.city || (billingDetails && billingDetails.billing_address.city)} type="text" required />
                    </div>
                    <div className={"input-wrap input-wrap--common " + (!billing_address.zip && isSubmittedForm ? 'form__error' : '')}>
                      <label>Postleitzahl</label>
                      <input name="zip" onChange={handleDeepInputChange} value={billing_address.zip || (billingDetails && billingDetails.billing_address.zip)} type="text" required /> </div>
                  </div>
                  <div className="billing-details__row billing-details__row--two-one">
                    <div className={"input-wrap input-wrap--common " + (!billing_address.street && isSubmittedForm ? 'form__error' : '')}>
                      <label>Strasse</label>
                      <input name="street" onChange={handleDeepInputChange} value={billing_address.street || (billingDetails && billingDetails.billing_address.street)} type="text" required />
                    </div>
                    <div className={"input-wrap input-wrap--common " + (!billing_address.house && isSubmittedForm ? 'form__error' : '')}>
                      <label>Hausnummer</label>
                      <input name="house" onChange={handleDeepInputChange} value={billing_address.house || (billingDetails && billingDetails.billing_address.house)} type="number" required />
                    </div>
                  </div>
                </Fragment>
              ) : ('')}
            </form>
          </div>
        </section>
        <button className="shop-btn shop-btn--next shop-btn--common shop-btn-right--common" onClick={handleNextStepBtn} />
      </Fragment>
    );
  }
}

export default connect((state) => {
  return {
    deliveryAddress: state.delivery.deliveryAddress,
    billingDetails: state.delivery.billingDetails
  }
}, {getBillingDetails})(BillingDetails);


// WEBPACK FOOTER //
// ./src/components/DeliverySteps/BillingDetails.js